import flat from 'lodash/flatten';
import { isXunda } from './index';
import { isSubAccount } from '../consts/multiAccountConfig';

const QW_ROLE_MAP = {
  '企微管理员': 1,
  '企微客服经理': 2,
  '企微客服人员': 3,
  '企微运营专员': 4,
  '管理员': 1,
  '客服经理': 2,
  '客服人员': 3,
  '运营专员': 4,
};

const LEADS_ROLE_MAP = {
  '管理员': 'OPERATOR_ROLE_LEADS_CMANAGER',
  '超级管理员': 'OPERATOR_ROLE_LEADS_MANAGER',
  '服务商人员': 'OPERATOR_ROLE_LEADS_AGENCY',
  '广告优化师': 'OPERATOR_ROLE_LEADS_ADOPERATOR',
  '客服经理': 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER',
  '客服人员': 'OPERATOR_ROLE_LEADS_CEMPLOYEE',
  '线索转发助手': 'OPERATOR_ROLE_LEADS_ASSISTANT',
  '数据分析人员': 'OPERATOR_ROLE_LEADS_DATA_ANALYST',
  '线索免登录超级观察者': 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER',
  '线索免登录观察者': 'OPERATOR_ROLE_LEADS_OBSERVER',
};

/**
 * 完整的前端路由，包含所有页面，未鉴权
 */
export const FULL_ROUTE = [
  {
    path: '/',
    isMenu: false,
    component: null,
    routes: [
      {
        path: '/leads',
        title: '线索管理',
        isMenu: true,
        component: null,
        routes: [
          {
            path: '/leads/leadsManage',
            title: '线索管理',
            isMenu: true,
            iconClassName: 'icon-menu-leads-list',
            component: null,
            routes: [
              {
                path: '/leads/leadsManage/company',
                title: '全公司线索',
                isMenu: true,
                component: true,
              },
              {
                path: '/leads/leadsManage/team',
                title: '团队线索',
                isMenu: true,
                component: true,
              },
              {
                path: '/leads/leadsManage/personal',
                title: '个人线索',
                isMenu: true,
                component: true,
              },
              {
                path: '/leads/leadsManage/companytestdatas',
                title: '全公司线索-测试数据',
                isMenu: false,
                component: true,
              },
            ],
          },
          {
            path: '/leads/pool',
            title: '线索公海池',
            isMenu: true,
            iconClassName: 'icon-menu-leads-pool',
            component: null,
            routes: [
              {
                path: '/leads/pool/leadsPool',
                title: '线索公海池',
                isMenu: true,
                component: true,
                routes: [
                  {
                    path: '/leads/pool/leadsPool/testdatas',
                    title: '线索公海池-测试数据',
                    isMenu: false,
                    component: true,
                  },
                ],
              },
            ],
          },
          {
            path: '/leads/calling',
            title: '通话记录',
            isMenu: true,
            iconClassName: 'icon-menu-leads-pool',
            component: null,
            routes: [
              {
                path: '/leads/calling/callingManage',
                title: '通话记录',
                isMenu: true,
                component: true,
              },
            ]
          },
        ],
      },
      {
        path: '/componentReport',
        title: '会话管理',
        isMenu: true,
        component: null,
        routes: [
          {
            path: '/componentReport/reportList',
            title: '会话列表',
            isMenu: true,
            iconClassName: 'icon-menu-consult',
            component: null,
            routes: [
              {
                path: '/componentReport/reportList/componentReport',
                title: '会话列表',
                isMenu: true,
                component: true,
              },
            ],
          },
        ],
      },
      {
        path: '/fan',
        title: '粉丝运营',
        isMenu: true,
        component: null,
        routes: [
          {
            path: '/fan/wx',
            title: '个微好友管理',
            isMenu: true,
            iconClassName: 'icon-menu-offocial-manage',
            component: null,
            routes: [
              {
                path: '/fan/wx/company',
                title: '全公司微信好友',
                isMenu: true,
                component: true,
              },
              {
                path: '/fan/wx/team',
                title: '团队微信好友',
                isMenu: true,
                component: true,
              },
              {
                path: '/fan/wx/personal',
                title: '个人微信好友',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/fan/official',
            title: '公众号授权',
            isMenu: true,
            iconClassName: 'icon-menu-offocial-manage',
            component: null,
            routes: [
              {
                path: '/fan/official/offocialAccounts',
                title: '公众号授权',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/fan/fans',
            title: '粉丝管理',
            isMenu: true,
            iconClassName: 'icon-menu-fan-manage',
            component: null,
            routes: [
              {
                path: '/fan/fans/fansManage',
                title: '粉丝管理',
                isMenu: true,
                component: true,
              },
              {
                path: '/fan/fans/tag',
                title: '标签识别',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/fan/reply',
            title: '消息管理',
            isMenu: true,
            iconClassName: 'icon-menu-message-manage',
            component: null,
            routes: [
              {
                path: '/fan/reply/messageManage',
                title: '被关注回复',
                isMenu: true,
                component: true,
              },
            ],
          },
        ],
      },
      {
        path: '/system',
        title: '系统设置',
        isMenu: true,
        component: null,
        routes: [
          {
            path: '/system/group',
            title: '团队设置',
            isMenu: true,
            iconClassName: 'icon-menu-group-setting',
            component: null,
            routes: [
              {
                path: '/system/group/employeeManage',
                title: '员工管理',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/group/groupManage',
                title: '团队管理',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/system/permission',
            title: '角色权限设置',
            isMenu: true,
            iconClassName: 'icon-menu-role-setting',
            component: null,
            routes: [
              {
                path: '/system/permission/rolePrivileManage',
                title: '角色权限设置',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/system/leadsManageSetting',
            title: '线索管理设置',
            isMenu: true,
            iconClassName: 'icon-menu-leads-manage',
            component: null,
            routes: [
              {
                path: '/system/leadsManageSetting/clue',
                title: '线索分配',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/recycle',
                title: '线索回收',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/sms',
                title: '短信通知',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/wechat',
                title: '微信提醒',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/cleaning',
                title: '线索清洗',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/label',
                title: '标签管理',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/state',
                title: '状态管理',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsManageSetting/call',
                title: '外呼设置',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/system/leadsForward',
            title: '线索转发设置',
            isMenu: true,
            iconClassName: 'icon-menu-leads-forward',
            component: null,
            routes: [
              {
                path: '/system/leadsForward/Filed',
                title: '线索字段转换配置',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/leadsForward/Api',
                title: '线索转发API配置',
                isMenu: true,
                component: true,
                routes: [
                  {
                    path: '/system/leadsForward/Api/interfaceSetting',
                    title: '推送接口配置',
                    isMenu: false,
                    component: true,
                  },
                  {
                    path: '/system/leadsForward/Api/leadsApiData',
                    title: '回传详情',
                    isMenu: false,
                    component: true,
                  },
                ],
              },
            ],
          },
          {
            path: '/system/multiAccount',
            title: '绑定账号权限',
            isMenu: true,
            iconClassName: 'icon-menu-account-permission',
            component: null,
            routes: [
              {
                path: '/system/multiAccount/bindlist',
                title: '绑定列表',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/multiAccount/bindHistory',
                title: '绑定历史',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/multiAccount/authList',
                title: '授权列表',
                isMenu: true,
                component: true,
              },
              {
                path: '/system/multiAccount/authHistory',
                title: '授权历史',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/system/leadsAuth',
            title: '线索授权',
            isMenu: true,
            iconClassName: 'icon-menu-leads-auth',
            component: null,
            routes: [
              {
                path: '/system/leadsAuth/authorization',
                title: '线索授权',
                isMenu: true,
                component: true,
              },
            ],
          },
        ],
      },
      {
        path: '/qw',
        title: '企微运营',
        isMenu: true,
        component: null,
        routes: [
          {
            path: '/qw/setting',
            title: '系统设置',
            isMenu: true,
            iconClassName: 'icon-menu-qw-system',
            component: null,
            routes: [
              {
                path: '/qw/setting/auth',
                title: '企业微信授权',
                isMenu: true,
                component: true,
              },
              {
                path: '/qw/setting/employee',
                title: '员工管理',
                isMenu: true,
                component: true,
              },
              {
                path: '/qw/setting/team',
                title: '团队管理',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/qw/acquisition',
            title: '引流获客',
            isMenu: true,
            iconClassName: 'icon-menu-qw-customer',
            component: null,
            routes: [
              {
                path: '/qw/acquisition/drainage',
                title: '引流获客',
                isMenu: true,
                component: true,
                routes: [
                  {
                    path: '/qw/acquisition/drainage/create',
                    title: '新建渠道活码',
                    isMenu: false,
                    component: true,
                  },
                  {
                    path: '/qw/acquisition/drainage/edit/:id',
                    title: '编辑渠道活码',
                    isMenu: false,
                    component: true,
                  },
                  {
                    path: '/qw/acquisition/drainage/detail/:id',
                    title: '渠道活码详情',
                    isMenu: false,
                    component: true,
                  },
                ],
              },
            ],
          },
          {
            path: '/qw/customer',
            title: '客户管理',
            isMenu: true,
            iconClassName: 'icon-menu-qw-customer',
            component: null,
            routes: [
              {
                path: '/qw/customer/customerList',
                title: '客户列表',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/qw/message',
            title: '消息管理',
            isMenu: true,
            iconClassName: 'icon-menu-qw-message',
            component: null,
            routes: [
              {
                path: '/qw/message/welcome',
                title: '欢迎语',
                isMenu: true,
                component: true,
              },
              {
                path: '/qw/message/remind',
                title: '消息提醒',
                isMenu: true,
                component: true,
              }
            ]
          }, {
            path: '/qw/conversation',
            title: '会话存档',
            isMenu: true,
            iconClassName: 'icon-menu-qw-archive',
            component: null,
            routes: [
              {
                path: '/qw/conversation/config',
                title: '权限配置',
                isMenu: true,
                component: true,
              },
              {
                path: '/qw/conversation/archive',
                title: '会话存档',
                isMenu: true,
                component: true,
              }
            ]
          }
        ]
      },
      {
        path: '/analysis',
        title: '分析应用',
        isMenu: true,
        component: null,
        routes: [
          {
            path: '/analysis/leadsData',
            title: '线索数据分析',
            isMenu: true,
            iconClassName: 'icon-menu-leads-list',
            component: null,
            routes: [
              {
                path: '/analysis/leadsData/employee',
                title: '人效分析',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/analysis/rule',
            title: '上报规则设置',
            isMenu: true,
            iconClassName: 'icon-menu-qw-system',
            component: null,
            routes: [
              {
                path: '/analysis/rule/leads',
                title: '线索上报',
                isMenu: true,
                component: true,
              },
              {
                path: '/analysis/rule/qw',
                title: '企微上报',
                isMenu: true,
                component: true,
              },
            ],
          },
          {
            path: '/analysis/upload',
            title: '数据上报统计',
            isMenu: true,
            iconClassName: 'icon-upload-analysis',
            component: null,
            routes: [
              {
                path: '/analysis/upload/total',
                title: '上报统计分析',
                isMenu: true,
                component: true,
              },
              {
                path: '/analysis/upload/detail',
                title: '上报明细',
                isMenu: true,
                component: true,
              },
            ],
          }
        ]
      },
    ]
  }
];

/**
 * 角色：
 * OPERATOR_ROLE_LEADS_CMANAGER 管理员
 * OPERATOR_ROLE_LEADS_MANAGER 超级管理
 * OPERATOR_ROLE_LEADS_AGENCY 服务商
 * OPERATOR_ROLE_LEADS_ADOPERATOR 优化师
 * OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER 客服经理
 * OPERATOR_ROLE_LEADS_CEMPLOYEE 客服人员
 * OPERATOR_ROLE_LEADS_ASSISTANT 线索转发助手
 * OPERATOR_ROLE_LEADS_DATA_ANALYST 数据分析人员
 * OPERATOR_ROLE_LEADS_SUPER_OBSERVER 线索免登录超级观察者
 * OPERATOR_ROLE_LEADS_OBSERVER 线索免登录观察者
 */

export const isLeadsRole = (...roles) => {
  const { originRole } = window.pageProps;
  if (!originRole) return false;
  /**
   * 免登录角色有最高级权限，属于特殊规则的角色
   * 相当于没有写权限的超管
   */
  const freeLoginRoles = [
    '线索免登录观察者',
    '线索免登录超级观察者',
  ];
  roles = flat(roles);
  for (const role of roles) {
    if (LEADS_ROLE_MAP[role] === originRole) return true;
    if (role === '免登录' && isLeadsRole(freeLoginRoles)) return true;
  }
  if (roles.length > 0) return false;
  const values = new Set(Object.values(LEADS_ROLE_MAP));
  return values.has(originRole);
};

export const isQwRole = (...roles) => {
  const { wxWorkRole } = window.pageProps;
  if (wxWorkRole === 0) return false;
  roles = flat(roles);
  for (const role of roles) {
    if (QW_ROLE_MAP[role] === wxWorkRole) return true;
  }
  if (roles.length > 0) return false;
  const values = new Set(Object.values(QW_ROLE_MAP));
  return values.has(wxWorkRole);
};

export const isQwAuthed = () => {
  const { corpId } = window.pageProps;
  return !!corpId;
};

export const hasPrivilege = (...privileges) => {
  privileges = flat(privileges);
  const oldPrivileges = window.pageProps.privileges || [];
  const whitePrivileges = window.pageProps.privilegesInWhite || [];
  const mergedPrivileages = oldPrivileges.concat(whitePrivileges);
  if (privileges.length < 1) return false;
  return privileges.every((privilege) => mergedPrivileages.includes(privilege));
};

const permissionMap = {
  '/qw/setting/auth': () => {
    if (isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    if (isQwAuthed() && isQwRole('企微管理员')) return true;
    if (isLeadsRole('客服经理')) return isXunda('车讯达');
    return false;
  },
  '/qw/setting/team': () => {
    if (isXunda('车讯达')) return false;
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/setting/employee': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/customer/customerList': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员', '广告优化师', '服务商人员')) return true;
    return isQwRole('企微管理员', '企微客服经理', '企微客服人员');
  },
  '/qw/message/welcome': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员', '企微客服经理', '企微客服人员');
  },
  '/qw/message/remind': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员', '企微客服经理', '企微客服人员');
  },
  '/qw/conversation/config': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/conversation/archive': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/acquisition/drainage': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/acquisition/drainage/create': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/acquisition/drainage/edit/:id': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/qw/acquisition/drainage/detail/:id': () => {
    if (!isQwAuthed()) return false;
    if (!isQwRole() && isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    return isQwRole('企微管理员');
  },
  '/analysis/rule/qw': () => {
    if (isLeadsRole('免登录', '管理员', '超级管理员', '广告优化师', '服务商人员')) return true;
    if (isQwAuthed() && isQwRole('企微管理员')) return true;
    if (!isLeadsRole()) return isQwRole('企微管理员', '企微客服经理');
  },
  '/leads/leadsManage/personal': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员', '客服经理', '客服人员');
  },
  '/leads/leadsManage/team': () => {
    return isLeadsRole('客服经理');
  },
  '/leads/leadsManage/company': () => {
    if (!isLeadsRole()) return false;
    return !isLeadsRole('客服经理', '客服人员');
  },
  '/leads/leadsManage/companytestdatas': () => {
    if (!isLeadsRole()) return false;
    return !isLeadsRole('客服经理', '客服人员');
  },
  '/leads/pool/leadsPool': () => {
    if (isLeadsRole('免登录', '管理员', '超级管理员')) return true;
    if (isSubAccount()) return false;
    if (isLeadsRole('客服经理', '客服人员')) return hasPrivilege('LEADS_PUBLIC_POOL_VIEW_LIST');
    return false;
  },
  '/leads/pool/leadsPool/testdatas': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/leads/calling/callingManage': () => {
    return !isSubAccount()
  },
  '/componentReport/reportList/componentReport': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/fan/wx/company': () => {
    if (!hasPrivilege('WECHAT_FRIEND_VISIBLE')) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/fan/wx/team': () => {
    if (!hasPrivilege('WECHAT_FRIEND_VISIBLE')) return false;
    return isLeadsRole('客服经理');
  },
  '/fan/wx/personal': () => {
    if (!hasPrivilege('WECHAT_FRIEND_VISIBLE')) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员', '客服经理', '客服人员');
  },
  '/fan/official/offocialAccounts': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/fan/fans/fansManage': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/fan/fans/tag': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/fan/reply/messageManage': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/group/employeeManage': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/group/groupManage': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/permission/rolePrivileManage': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsManageSetting/clue': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsManageSetting/recycle': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsManageSetting/sms': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsManageSetting/wechat': () => {
    return isLeadsRole('管理员', '超级管理员', '客服经理', '客服人员');
  },
  '/system/leadsManageSetting/cleaning': () => {
    if (isSubAccount()) return false;
    if (!isLeadsRole('免登录', '管理员', '超级管理员')) return false;
    return hasPrivilege('CALL_CLEANING_RULE_MANAGE');
  },
  '/system/leadsManageSetting/label': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsManageSetting/state': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsManageSetting/call': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsAuth/authorization': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/leadsForward/Filed': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员', '线索转发助手');
  },
  '/system/leadsForward/Api': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员', '线索转发助手');
  },
  '/system/leadsForward/Api/interfaceSetting': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员', '线索转发助手');
  },
  '/system/leadsForward/Api/leadsApiData': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员', '线索转发助手');
  },
  '/system/multiAccount/bindlist': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/multiAccount/bindHistory': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/multiAccount/authList': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/system/multiAccount/authHistory': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/analysis/leadsData/employee': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/analysis/rule/leads': () => {
    if (isSubAccount()) return false;
    return isLeadsRole('免登录', '管理员', '超级管理员', '服务商人员', '广告优化师');
  },
  '/analysis/upload/total': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员');
  },
  '/analysis/upload/detail': () => {
    return isLeadsRole('免登录', '管理员', '超级管理员', '服务商人员');
  },
};

/**
 * 查询一个路由是否可用
 * 如果不在标记列表中则默认为可用
 * 如果出现在标记列表中，需要根据权限参数判断
 */
const isValidRoute = (path) => {
  const checkFn = permissionMap[path];
  if (typeof checkFn !== 'function') return true;

  // 系统在企业微信客户端中打开时仅展示部分支持在企微中打开的页面
  // 目前仅支持在企业微信客户端中打开企微运营下的页面，权限同其他一致
  const from = (new URLSearchParams(window.location.search)).get('from');
  if (from === 'xd' || from === 'tmc') {
    const xdValid = [
      '/leads/leadsManage/company',
      '/leads/leadsManage/team',
      '/leads/leadsManage/personal',
      '/leads/pool/leadsPool',
      '/leads/leadsManage/companytestdatas',
      '/componentReport/reportList/componentReport',
      '/system/group/groupManage',
      '/system/group/employeeManage',
      '/system/permission/rolePrivileManage',
      '/system/leadsManageSetting/clue',
      '/system/leadsManageSetting/sms',
      '/system/leadsManageSetting/wechat',
      '/system/leadsManageSetting/label',
      '/analysis/leadsData/employee',
    ];
    if (!xdValid.includes(path)) return false;
  }
  return checkFn();
};

// 清理没有实际子页面的路由分支
export const clearEmptyRoute = (routeArr) => {
  const getUseful = (arr) => {
    if (!Array.isArray(arr)) return [];
    const usefuls = [];
    arr.forEach((item) => {
      const routeItem = { ...item, routes: getUseful(item.routes) };
      if (routeItem.component) {
        // 有实体页面，直接保存
        if (routeItem.routes.length < 1) {
          // 删掉没有实体页面的子路由
          delete routeItem.routes;
        }
        usefuls.push(routeItem);
      } else if (routeItem.routes.length > 0) {
        // 虽然没有实体页面但是子路由存在实体页面，是单纯的多级菜单节点
        usefuls.push(routeItem);
      }
    });
    return usefuls;
  };
  return getUseful(routeArr);
};

/**
 * 路由鉴权方法，接收角色和权限等参数，输出有权访问的路由
 */
export const authRoute = () => {
  if (!window._noPermissionRoutes) {
    window._noPermissionRoutes = new Set();
  }
  // 递归检查完整路由的没一个路由对当前角色是否可访问
  const check = (arr) => {
    const valids = [];
    arr.forEach((item) => {
      // 无访问权限在，直接退出
      if (!isValidRoute(item.path)) {
        window._noPermissionRoutes.add(item.path);
        return;
      }
      const copy = { ...item };
      if (Array.isArray(item.routes) && item.routes.length) {
        // 这这对子路由进行递归
        copy.routes = check(item.routes);
      }
      valids.push(copy);
    });
    return valids;
  };
  // 经过权限过滤的路由，可能存在没有实体页面（component）的路由分支
  const result = check(FULL_ROUTE);
  const routes = clearEmptyRoute(result);
  return routes;
};
